import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1344.9618,112.9406 C1321.5838,47.3226 1259.4658,-0.0004 1185.9418,-0.0004 L734.1768,-0.0004 C660.6518,-0.0004 598.5338,47.3226 575.1548,112.9406 L112.9998,112.9406 L112.9998,1919.9996 L1807.1178,1919.9996 L1807.1178,112.9406 L1344.9618,112.9406 Z M1694.1758,1807.0586 L225.9418,1807.0586 L225.9418,225.8816 L564.7648,225.8816 L564.7648,451.7656 L1355.3538,451.7656 L1355.3538,225.8816 L1694.1758,225.8816 L1694.1758,1807.0586 Z M677.7058,225.8816 L677.7058,169.4126 C677.7058,138.2406 703.0048,112.9406 734.1768,112.9406 L1185.9418,112.9406 C1217.1138,112.9406 1242.4118,138.2406 1242.4118,169.4126 L1242.4118,225.8816 L1242.4118,338.8246 L677.7058,338.8246 L677.7058,225.8816 Z M451.846,1016.471 L790.669,1016.471 L790.669,677.647 L451.846,677.647 L451.846,1016.471 Z M564.787,903.529 L677.728,903.529 L677.728,790.588 L564.787,790.588 L564.787,903.529 Z M903.611,790.588 L1468.318,790.588 L1468.318,677.647 L903.611,677.647 L903.611,790.588 Z M903.611,1355.294 L1468.318,1355.294 L1468.318,1242.353 L903.611,1242.353 L903.611,1355.294 Z M903.611,1016.471 L1242.434,1016.471 L1242.434,903.529 L903.611,903.529 L903.611,1016.471 Z M903.611,1581.177 L1242.434,1581.177 L1242.434,1468.236 L903.611,1468.236 L903.611,1581.177 Z M564.787,1468.235 L677.728,1468.235 L677.728,1355.294 L564.787,1355.294 L564.787,1468.235 Z M451.846,1581.177 L790.669,1581.177 L790.669,1242.353 L451.846,1242.353 L451.846,1581.177 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRubricLine = /*#__PURE__*/function (_Component) {
  _inherits(IconRubricLine, _Component);

  var _super = _createSuper(IconRubricLine);

  function IconRubricLine() {
    _classCallCheck(this, IconRubricLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconRubricLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRubric",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconRubricLine.displayName = "IconRubricLine";
  return IconRubricLine;
}(Component);

IconRubricLine.glyphName = 'rubric';
IconRubricLine.variant = 'Line';
IconRubricLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRubricLine;
export { IconRubricLine };